'use strict';
var ApplicationStore = require('../stores/ApplicationStore.js');
module.exports = {
    getTrackingEnabled(isPageNotFound) {
        let smt = window.SMT;
        let userType = ApplicationStore.getUserType();
        let companyCode = ApplicationStore.getCompanyCode();
        let pageName = '';
        
        if (!isPageNotFound) { 
             pageName = window.location.pathname.replace('/', '').replace(/[/]/gi, ':').split('.')[0].toLowerCase();
        }
        else {
            pageName = 'esetup:404';
        }

        if (pageName.substr(-1) === ':') {
            pageName = pageName.replace(/.$/,'');
        }

        switch (userType)
        {
            case 'I':
                pageName = 'fni:' + pageName;
                break;
            case 'A':
                pageName = 'fna:' + pageName;
                break;
            default:
                pageName = 'cfs:' + pageName;
                break;
        }
       
        smt.setTrackingField('SC_PAGE_NAME', pageName);
        smt.setTrackingField('SC_COMPANY_CODE', companyCode);
        smt.launchBootstrap();
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/OmnitureTracking.js